(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-open.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-open.js');

'use strict';

const {
  useMemo
} = React;
const {
  clx
} = svs.components.lbUtils;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  CompetitionLogo,
  LoginButton,
  PixArea,
  PlayButton,
  Registration,
  VisitGameButton
} = svs.components.marketplaceCompetition.overviewHero.common;
const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  capitalize,
  ordinalNumber
} = svs.components.marketplaceCompetition.overviewHero.helpers;
const {
  useMobileQuery
} = svs.components.marketplaceCompetition.overviewHero.hooks;
const {
  IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET
} = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState;
const UserNotLoggedIn = _ref => {
  let {
    competition,
    compName
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let {
    competition,
    compName
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Anm\xE4l dig till t\xE4vlingen")), React.createElement(Registration, {
    competition: competition
  })));
};
const UserHasNoBet = _ref3 => {
  var _competition$currentD;
  let {
    competition
  } = _ref3;
  const {
    firstDrawNumber,
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const closeTime = (_competition$currentD = competition.currentDraw) !== null && _competition$currentD !== void 0 && _competition$currentD.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "L\xE4mna in ditt spel till ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "L\xE4mna in ditt spel till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "L\xE4mna in ditt spel!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("p", {
    className: "overview-hero-sub-small"
  }, "Spelstopp: ".concat(capitalize(closeTime))), React.createElement(PlayButton, {
    competition: competition
  })));
};
const UserHasBet = _ref4 => {
  var _competition$currentD2;
  let {
    competition
  } = _ref4;
  const {
    firstDrawNumber,
    currentDrawNumber
  } = (competition === null || competition === void 0 ? void 0 : competition.details) || {};
  const closeTime = (_competition$currentD2 = competition.currentDraw) !== null && _competition$currentD2 !== void 0 && _competition$currentD2.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "Du har l\xE4mnat in spelet till ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "Du har l\xE4mnat in spelet till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("h2", null, "Du har l\xE4mnat in spelet f\xF6r omg\xE5ngen!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("p", {
    className: "overview-hero-sub-small"
  }, "Spelstopp: ".concat(capitalize(closeTime))), React.createElement(VisitGameButton, {
    competition: competition
  })));
};
const CompetitionOpenDrawOpen = _ref5 => {
  let {
    branding,
    competition,
    userState
  } = _ref5;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition,
          compName: compName
        });
    }
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: clx('competition-overview-hero competition-open-draw-open', userState)
  }, renderContentBasedOnUserState(userState)), React.createElement(PixArea, {
    branding: branding,
    competition: competition,
    isMobile: isMobile,
    isVisible: userState === HAS_NO_CURRENT_BET
  }));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionOpenDrawOpen', CompetitionOpenDrawOpen);

 })(window);